import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
//LAng detector probably not needed as the language is set in the settings for the user
//import LanguageDetector from "i18next-browser-languagedetector";

// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
import cs from "./translations/cs_CZ.json";
import en from "./translations/en_GB.json";

import moment from "moment";

import "moment/locale/cs";
import "moment/locale/en-gb";
import "moment/locale/de";
import "moment/locale/sk";

moment.locale("cs");

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //.use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    lng: "cs",
    fallbackLng: "cs",
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      wait: true,
    },
    resources: {
      cs: {
        translation: cs,
      },
      en: {
        translation: en,
      },
    },
  });

moment.updateLocale('cs', {
  months : [
    i18n.t("month.jan"), i18n.t("month.feb"), i18n.t("month.mar"),
    i18n.t("month.apr"), i18n.t("month.may"), i18n.t("month.jun"),
    i18n.t("month.jul"), i18n.t("month.aug"), i18n.t("month.sep"),
    i18n.t("month.oct"), i18n.t("month.nov"), i18n.t("month.dec"),
  ]
});

export default i18n;
